"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CloseIconTheme = void 0;
var _colors = require("../../colors");
var _internalTypography = require("../../internal/internal-typography");
var CloseIconTheme = exports.CloseIconTheme = {
  "default": {
    backgroundColor: _colors.FullPalette.GREY_E500,
    color: _colors.FullPalette.EVERGREEN_700
  },
  hover: {
    backgroundColor: _colors.FullPalette.GREY_800,
    color: _colors.FullPalette.GREY_E500
  }
};
var Theme = {
  "default": {
    typography: _internalTypography.ChipText,
    hoverBorderColor: _colors.FullPalette.GREY_700,
    backgroundColor: _colors.FullPalette.GREY_E500,
    borderColor: _colors.FullPalette.GREY_E500
  },
  error: {
    typography: _internalTypography.DangerChipText,
    hoverBorderColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.GREY_E500,
    borderColor: _colors.FullPalette.GREY_E500
  },
  unavailable: {
    typography: _internalTypography.UnavailableChipText,
    hoverBorderColor: _colors.FullPalette.GREY_700,
    backgroundColor: _colors.FullPalette.GREY_E500,
    borderColor: _colors.FullPalette.GREY_E500
  },
  hover: {
    typography: _internalTypography.ChipText,
    hoverBorderColor: _colors.FullPalette.GREY_700,
    backgroundColor: _colors.FullPalette.GREY_E500,
    borderColor: _colors.FullPalette.GREY_E500
  }
};
var _default = exports["default"] = Theme;